import React from "react";
import { Paper } from "@mui/material";

const GrayBorder = () => {
  return <Paper sx={{ height: "0.4px", bgcolor: "lightgray", width: "100%",borderRadius:"0px" }} elevation={0}></Paper>;
};

export default GrayBorder;
